module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAABkCAYAAABHLFpgAAAALElEQVQYlWN49OjRfyYGBgaGIUT8//8fSqBx0Yh///4RL8vAwAAVQ2MNOwIAl6g6KkOJwk8AAAAASUVORK5CYII="


/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery-ui/themes/base/images/ui-bg_highlight-soft_75_cccccc_1x100.png
 ** module id = 299
 ** module chunks = 1
 **/